import {Transaction} from "./Transaction";

export class DisconnectService {
    constructor({
                    ubCustNo = null,
                    csn = null,
                    endDate = null,
                    success = null,
                    reason = null,
                } = {}) {
        this.ubCustNo = ubCustNo;
        this.csn = csn;
        this.endDate = endDate;
        this.success = success;
        this.reason = reason;
    }
}
export function createDisconnectService(data) {
    return Object.freeze(new DisconnectService(data));
}

export function createDisconnectServiceWithHeaderName(data) {
    return new DisconnectService({
        ubCustNo: data.UBCustNo,
        csn: data.Csn,
        endDate: data.EndDate
    });
}